import { render, staticRenderFns } from "./OidcGroups.vue?vue&type=template&id=2b17f917&"
import script from "./OidcGroups.vue?vue&type=script&lang=js&"
export * from "./OidcGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports